import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';

@Component({
    selector: 'ngc-mfa-login',
    templateUrl: './mfa-login.component.html',
    styleUrls: ['./mfa-login.component.scss']
})
export class MFALoginComponent implements OnInit {

    @Input() loginForm: UntypedFormGroup;
    @Input() loginFormErrors: any;
    @Input() loading$: BehaviorSubject<boolean>;
    @Input() phoneNumber: string;
    @Input()
    set isMFALoginView(isMFALoginView: boolean)  {
        if (!this._isMFALoginView
            && isMFALoginView
            && !this.disableResendCodeBtnTimer) {

            const disableResendCodeBtnSecondsEndDate = this.getDisableResendCodeBtnTimerToLocalStorage();
            const nowSeconds = Math.round(new Date().getTime() / 1000);
            const disableResendCodeBtnTimer = disableResendCodeBtnSecondsEndDate - nowSeconds;

            if (disableResendCodeBtnTimer > 0) {
                this.disableResendCodeBtnTimer = disableResendCodeBtnTimer;
                this.disableResendCodeBtnSecondsEndDate = disableResendCodeBtnSecondsEndDate;
                this.onDisableResendCodeBtnTimer();
            } else {
                if (this._isMFALoginView !== undefined) {
                    this.onRunDisableResendCodeBtnTimer();
                }
            }
        }
        this._isMFALoginView = isMFALoginView;
    }
    get isMFALoginView(): boolean {
        return this._isMFALoginView;
    }

    @Output() formSubmit = new EventEmitter<any>();
    @Output() backToCredentialsLogIn = new EventEmitter<void>();
    @Output() sendCodeAgain = new EventEmitter<void>();
    @Output() turnOnRecoveryCodeLoginView = new EventEmitter<void>();

    disableResendCodeBtnTimer = 0;
    disableResendCodeBtnSecondsEndDate: number;
    private readonly DEFAULT_DISABLE_RESEND_CODE_BTN_DURATION = 60;
    private _isMFALoginView: boolean;

    constructor(private changeDetector: ChangeDetectorRef) { }

    ngOnInit(): void {
    }

    onFormSubmit(loginFormValue: any): void {
        this.formSubmit.emit(loginFormValue);
    }

    onBackToCredentialsLogIn(): void {
        this.backToCredentialsLogIn.emit();
    }

    onSendCodeAgain(): void {
        this.onRunDisableResendCodeBtnTimer();
        this.sendCodeAgain.emit();
    }

    private onRunDisableResendCodeBtnTimer() {
        this.disableResendCodeBtnSecondsEndDate = Math.round(new Date().getTime() / 1000) + this.DEFAULT_DISABLE_RESEND_CODE_BTN_DURATION;
        this.setDisableResendCodeBtnTimer();
        this.onDisableResendCodeBtnTimer();
    }

    onTurnOnRecoveryCodeLoginView(): void {
        this.turnOnRecoveryCodeLoginView.emit();
    }

    onDisableResendCodeBtnTimer() {
        if (this.disableResendCodeBtnTimer > 0) {
            this.setDisableResendCodeBtnTimer();

            setTimeout(this.onDisableResendCodeBtnTimer.bind(this), 1000);
        } else {
            this.disableResendCodeBtnTimer = 0;
        }
        this.changeDetector.detectChanges();
    }

    private setDisableResendCodeBtnTimer(): void {
        const nowSeconds = Math.round(new Date().getTime() / 1000);
        this.disableResendCodeBtnTimer = this.disableResendCodeBtnSecondsEndDate - nowSeconds;
        this.disableResendCodeBtnSecondsEndDate = this.disableResendCodeBtnSecondsEndDate > 0 ? this.disableResendCodeBtnSecondsEndDate : 0;
        window.localStorage.setItem('disableResendCodeBtnSecondsEndDate', `${this.disableResendCodeBtnSecondsEndDate}`);
    }

    private getDisableResendCodeBtnTimerToLocalStorage(): number {
        const disableResendCodeBtnSecondsEndDate = window.localStorage.getItem('disableResendCodeBtnSecondsEndDate');
        return (disableResendCodeBtnSecondsEndDate !== 'undefined') ? +JSON.parse(disableResendCodeBtnSecondsEndDate) : 0;
    }
}
